import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Affiliate } from 'src/app/models/Affiliate';
import { ToastService } from 'src/app/shared/components/toast/toast.service';

/**
 * Gaveta de detalhe rápido da lista de contas gerenciadas (decisão do mockup
 * aprovado em 27/10, CU-17tm466u6ga): abre com os dados que a linha já tem, sem
 * chamada nova — o `/partner/statistics/:id` exige API ligada e conta ativa, e a
 * gaveta precisa funcionar para qualquer linha.
 */
@Component({
  selector: 'app-account-drawer',
  templateUrl: './account-drawer.component.html',
  styleUrls: ['./account-drawer.component.scss'],
})
export class AccountDrawerComponent {
  @Input() account: Affiliate;
  @Input() canSeeStatistics = false;
  @Input() canSimulate = false;
  @Output() closed = new EventEmitter<void>();
  @Output() simulate = new EventEmitter<Affiliate>();

  constructor(private toastService: ToastService) {}

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.close();
  }

  get initials(): string {
    const parts = (this.account?.name || '').trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
  }

  close(): void {
    this.closed.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  copyEmail(): void {
    navigator.clipboard.writeText(this.account.email);
    this.toastService.success('E-mail copiado com sucesso!');
  }
}
